/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_line_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One numeric column draws a single trend line.`)
};

const es_line_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una columna numérica dibuja una única línea de tendencia.`)
};

const de_line_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine numerische Spalte zeichnet eine einzelne Trendlinie.`)
};

const nl_line_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén numerieke kolom tekent één trendlijn.`)
};

const fr_line_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une colonne numérique dessine une seule courbe de tendance.`)
};

const it_line_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una colonna numerica disegna una singola linea di tendenza.`)
};

const pt_br2_line_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coluna numérica desenha uma única linha de tendência.`)
};

const pt_line_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coluna numérica desenha uma única linha de tendência.`)
};

const ja_line_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値列が1つの場合、単一の傾向線が描画されます。`)
};

const zh_line_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一列数值绘制出单条趋势线。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const line_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.line_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("line_ex1", locale)
	if (locale === "en") return en_line_ex1(inputs)
	if (locale === "es") return es_line_ex1(inputs)
	if (locale === "de") return de_line_ex1(inputs)
	if (locale === "nl") return nl_line_ex1(inputs)
	if (locale === "fr") return fr_line_ex1(inputs)
	if (locale === "it") return it_line_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_line_ex1(inputs)
	if (locale === "pt") return pt_line_ex1(inputs)
	if (locale === "ja") return ja_line_ex1(inputs)
	return zh_line_ex1(inputs)
};